import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'GreenButton',
  props: {
    slug: {}
  },
  emits: ["click"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.slug)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          class: "btn btn--green",
          to: _ctx.slug ?? ''
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, [
              _renderSlot(_ctx.$slots, "default")
            ])
          ]),
          _: 3
        }, 8, ["to"]))
      : _createCommentVNode("", true),
    (!_ctx.slug)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "btn btn--green",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click')))
        }, [
          _createElementVNode("span", null, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})